module.exports = __webpack_public_path__ + "static/media/background-lobby-ms624.f29365a3.png";